import { MsalProvider } from '@azure/msal-react'
import { DateFnsLocaleProvider } from '@if/core/date'
import i18n, { initializeI18N } from '@if/core/i18n'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { UserProvider } from './shared/contexts/UserContext'
import App from './shell/App'
import './index.css'
import { initializeAppInsights } from './shared/services/AppInsights'
import { initializeMsal } from './shared/services/Authentification'
import { reportErrorToConsole, setupTracking } from './shared/services/error-logger'

const ai = initializeAppInsights()
setupTracking(ai)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})
const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')
const root = createRoot(container)
Promise.all([initializeMsal(), initializeI18N()])
  .then(([msalInstance]) => {
    root.render(
      <Suspense fallback="loading">
        <I18nextProvider i18n={i18n}>
          <DateFnsLocaleProvider>
            <MsalProvider instance={msalInstance}>
              <QueryClientProvider client={queryClient}>
                <UserProvider>
                  <App />
                </UserProvider>
              <div
                style={{
                  fontSize: '24px',
                }}
              >
                <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-right" />
              </div>
              </QueryClientProvider>
            </MsalProvider>
          </DateFnsLocaleProvider>
        </I18nextProvider>
      </Suspense>,
    )
  })
  .catch(reportErrorToConsole)
